export const  fonts = [

    // ========================
    // Web Safe Fonts
    // ========================
    "Arial",
    "Helvetica",
    "Verdana",
    "Tahoma",
    "Trebuchet MS",
    "Times New Roman",
    "Georgia",
    "Garamond",
    "Courier New",
    "Brush Script MT",

    // ========================
    // Windows Fonts
    // ========================
    "Segoe UI",
    "Segoe UI Variable",
    "Calibri",
    "Cambria",
    "Candara",
    "Constantia",
    "Corbel",
    "Franklin Gothic Medium",
    "Impact",
    "Lucida Console",
    "Lucida Sans Unicode",
    "Microsoft Sans Serif",
    "Palatino Linotype",
    "Sitka",
    "Sylfaen",
    "Bahnschrift",
    "Bookman Old Style",
    "Century Gothic",
    "Comic Sans MS",
    "Consolas",
    "Copperplate Gothic",
    "Ebrima",
    "Gadugi",
    "HoloLens MDL2 Assets",
    "Ink Free",
    "Javanese Text",
    "Leelawadee UI",
    "Malgun Gothic",
    "Marlett",
    "Meiryo",
    "Microsoft Himalaya",
    "Microsoft JhengHei",
    "Microsoft New Tai Lue",
    "Microsoft PhagsPa",
    "Microsoft Tai Le",
    "Microsoft YaHei",
    "MingLiU",
    "Mongolian Baiti",
    "MS Gothic",
    "MS PGothic",
    "MS Serif",
    "MS Sans Serif",
    "Myanmar Text",
    "Nirmala UI",
    "Segoe MDL2 Assets",
    "SimSun",
    "SimHei",
    "Yu Gothic",

    // ========================
    // macOS Fonts
    // ========================
    "San Francisco",
    "SF Pro Display",
    "SF Pro Text",
    "SF Mono",
    "Helvetica Neue",
    "Avenir",
    "Avenir Next",
    "Baskerville",
    "Big Caslon",
    "Bodoni 72",
    "Chalkboard",
    "Chalkboard SE",
    "Chalkduster",
    "Didot",
    "Futura",
    "Geneva",
    "Gill Sans",
    "Hoefler Text",
    "Marker Felt",
    "Menlo",
    "Monaco",
    "Noteworthy",
    "Optima",
    "Papyrus",
    "Snell Roundhand",
    "Trattatello",
    "American Typewriter",
    "Andale Mono",
    "Apple Chancery",
    "Apple SD Gothic Neo",
    "Copperplate",
    "DIN Alternate",
    "DIN Condensed",
    "Herculanum",
    "Kohinoor Bangla",
    "Kohinoor Devanagari",
    "Kohinoor Telugu",
    "Skia",
    "Thonburi",
    "Zapfino",

    // ========================
    // Linux / Open Source
    // ========================
    "Ubuntu",
    "Ubuntu Mono",
    "DejaVu Sans",
    "DejaVu Serif",
    "DejaVu Sans Mono",
    "Liberation Sans",
    "Liberation Serif",
    "Liberation Mono",
    "Noto Sans",
    "Noto Serif",
    "Noto Mono",
    "Cantarell",
    "Droid Sans",
    "Droid Serif",
    "Droid Sans Mono",
    "FreeMono",
    "FreeSans",
    "FreeSerif",
    "Source Sans Pro",
    "Source Serif Pro",
    "Source Code Pro",

    // ========================
    // Popular Google Fonts
    // ========================
    "Roboto",
    "Open Sans",
    "Lato",
    "Montserrat",
    "Oswald",
    "Raleway",
    "Poppins",
    "Merriweather",
    "Playfair Display",
    "Nunito",
    "Rubik",
    "Work Sans",
    "Inter",
    "Quicksand",
    "PT Sans",
    "PT Serif",
    "Fira Sans",
    "DM Sans",
    "Cabin",
    "Arimo",
    "Bitter",
    "Crimson Text",
    "Exo",
    "Karla",
    "Libre Baskerville",
    "Manrope",
    "Mukta",
    "Overpass",
    "Prompt",
    "Titillium Web",
    "Zilla Slab",
    "Anton",
    "Barlow",
    "Barlow Condensed",
    "Bebas Neue",
    "Cairo",
    "Dosis",
    "Hind",
    "Inconsolata",
    "Josefin Sans",
    "Lobster",
    "Mulish",
    "Orbitron",
    "Pacifico",
    "Righteous",
    "Saira",
    "Teko",
    "Varela Round",
    "Yanone Kaffeesatz",

    // ========================
    // Coding Fonts
    // ========================
    "Fira Code",
    "JetBrains Mono",
    "Cascadia Code",
    "IBM Plex Mono",
    "Hack",
    "Operator Mono",
    "Input Mono",
    "Anonymous Pro",
    "Red Hat Mono",
    "Space Mono",
    "Victor Mono",

    // ========================
    // Display / Decorative
    // ========================
    "Alfa Slab One",
    "Abril Fatface",
    "Bangers",
    "Cinzel",
    "Comfortaa",
    "Fredoka",
    "Great Vibes",
    "Indie Flower",
    "Lobster Two",
    "Permanent Marker",
    "Shadows Into Light",
    "Satisfy",
    "Tangerine",
    "Ultra",
    "Vollkorn",
    "Zeyada"
];
export default fonts;